import { render } from "./edit_staff_form.vue?vue&type=template&id=39707ede&scoped=true"
import script from "./edit_staff_form.vue?vue&type=script&lang=js"
export * from "./edit_staff_form.vue?vue&type=script&lang=js"

import "./edit_staff_form.vue?vue&type=style&index=0&id=39707ede&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39707ede"]])

export default __exports__